import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSun, faMoon } from "@fortawesome/free-solid-svg-icons";

const DarkMode = () => {
  
  let clickedClass = "clicked";
  const body = document.body;
  const lightTheme = "light";
  const darkTheme = "dark";
  // let theme;

  const [theme, setTheme] = useState("light");
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (localStorage) {
      let themeStorage = localStorage.getItem("theme");
      setTheme(themeStorage);
      setDarkMode(themeStorage === "dark");
    }
  }, []);

  if (theme === lightTheme || theme === darkTheme) {
    body.classList.add(theme);
  } else {
    body.classList.add(lightTheme);
  }

  const switchTheme = (e) => {
    if (theme === darkTheme) {
      body.classList.replace(darkTheme, lightTheme);
      e.target.classList.remove(clickedClass);
      localStorage.setItem("theme", "light");
      setTheme(lightTheme);
    } else {
      body.classList.replace(lightTheme, darkTheme);
      e.target.classList.add(clickedClass);
      localStorage.setItem("theme", "dark");
      setTheme(darkTheme);
    }
  };



  return (

    <div className={theme === "dark" ? clickedClass : ""}>
      <div className="container">
        <div className="col-md-12">
          <div className="row">
            <div style={{ display: "grid", alignItems: "center", padding:"0 0.5rem"  }}> <FontAwesomeIcon icon={faSun} onChange={() => setDarkMode(!darkMode)} style={{ color: darkMode ? "grey" : "#1A9185" }} /></div>
            <div style={{ top: "5px" }}>
              <label className="switch">
                <input type="checkbox" defaultChecked={darkMode} checked={darkMode} onChange={() => setDarkMode(!darkMode)} onClick={(e) => switchTheme(e)} />
                <span className="slider round"> </span>
              </label>
            </div>
            <div style={{ display: "grid", alignItems: "center", padding:"0 0.5rem" }}><FontAwesomeIcon icon={faMoon} onChange={() => setDarkMode(!darkMode)} style={{ color: darkMode ? "#1A9B60" : "grey" }} /></div>
          </div>
      </div>
      </div>
    </div>

  );
};

export default DarkMode;